import { render, staticRenderFns } from "./TermiAnticiInq.vue?vue&type=template&id=185bbfd8"
import script from "./TermiAnticiInq.vue?vue&type=script&lang=js"
export * from "./TermiAnticiInq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185bbfd8')) {
      api.createRecord('185bbfd8', component.options)
    } else {
      api.reload('185bbfd8', component.options)
    }
    module.hot.accept("./TermiAnticiInq.vue?vue&type=template&id=185bbfd8", function () {
      api.rerender('185bbfd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/TermiAnticiInq.vue"
export default component.exports